// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import shareimage from "../../../../assets/images/share_svg.svg";
import { trendingsectionunslick } from "../../../../shared/sliderSetting.js"
import 'aos/dist/aos.css';
import { Footer } from '../../../common/footer/footer';
import { ArticlesCardJSX } from '../../../common/articlesCard/articlesCard';
import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import './articleDetails.css'; 
import { categoryEnum, convertToCanadianDateTime, mixPannelEvent } from "../../../../shared/helper";
import InsuranceArticleDetailsJsx from "./insuranceArticleDetails";
import RealestateArticleDetailsJsx from "./reaEstateArticleDetails ";
import InvestmentArticleDetailsJsx from "./investmentArticleDetails";
import MortgageArticleDetailsJsx from "./mortgageArticleDetails";
import BankingArticleDetailsJsx from "./banking";

const ArticleDetailsJsx = (props) => {
  const {
    detailsData,
    similarArticle
  } = props;

  const { t } = useTranslation();
  const [hasStartedReading, setHasStartedReading] = useState(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      // Clear existing timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      // Set a new timeout to trigger after user stops scrolling for 2 seconds
      scrollTimeoutRef.current = setTimeout(() => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        
        // Calculate scroll percentage
        const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;
        
        // Trigger event when user scrolls past 10% and hasn't been triggered yet
        if (scrollPercentage > 10 && !hasStartedReading) {
          setHasStartedReading(true);
          mixPannelEvent({
            eventName: "started_reading_article",
            data: {
              title: detailsData?.title?.rendered,
              category: detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name,
              author: detailsData?.['_embedded']?.['author']?.[0]?.name,
              scrollPercentage: Math.round(scrollPercentage),
              url: window.location.href
            }
          });
        }
      }, 2000); // 2 second delay after scrolling stops
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup function
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [detailsData, hasStartedReading]);

  const shareArticle = async () => {
    mixPannelEvent({
      eventName: "shared_article",
      data: {
        title:detailsData?.title?.rendered
      }
    })
    try {

      const shareData = {
        title: detailsData?.title?.rendered,
        text: detailsData?.title?.rendered,
        url: window.location.href,
      };

      await navigator.share(shareData);
    } catch (err) {
      // resultPara.textContent = `Error: ${err}`;
      console.log(`Error: ${err}`);
    }
  }

  return (
    <>

    {/* old article design */}
    {detailsData?.acf?.enable_template !== 'enable' &&
      <section className="homecustom">
        <section  >
          <div className="container"> 
          <div className="row col-12">
           
          <p className="articleflow">{t("COMMON.HOME")} / {detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name} / <span className="articleflowsub">{detailsData?.title?.rendered}</span></p>
         
          <h1 className="articlesubheading">{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</h1>
          <div className="subunderlines"></div>
          </div>
           
            <div className="modal-header articlepart">
              <h1 className="articleTitle">{detailsData?.title?.rendered}</h1>
            </div>
            
          

            <div className="articlepart articlenormal" >
              <div className="d-flex basicuserdetails">
                <div className="userimage">
                  <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                </div>
                <div className="name">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
              </div>
              <p className="articlepublishdate ">{convertToCanadianDateTime(detailsData?.date)}</p>
            </div>
            <div className="modal-body  articlepart">
              <div className="blog-image-dv articleimage"><img src={detailsData?.['_embedded']?.['wp:featuredmedia']?.[0]?.source_url} alt={' '} />
              </div>
              <div className="blog-content-dv articledetails" dangerouslySetInnerHTML={{ __html: detailsData?.content?.rendered }}></div>
            </div>
          </div>
        </section>
  
      </section>
    }
    {/* old article design ends */}

    {detailsData?.acf?.enable_template === 'enable' &&
      <>
      {detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.slug === categoryEnum.insurance && 
    
        <InsuranceArticleDetailsJsx detailsData={detailsData} />
      }

      {detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.slug === categoryEnum.realEstate && 
    
        <RealestateArticleDetailsJsx detailsData={detailsData} />
      }

      {detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.slug === categoryEnum.investment && 
    
        <InvestmentArticleDetailsJsx detailsData={detailsData} />
      }
      
      {detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.slug === categoryEnum.mortgage && 
    
        <MortgageArticleDetailsJsx detailsData={detailsData} />
      }
      
      {detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.slug === categoryEnum.banking && 
    
        <BankingArticleDetailsJsx detailsData={detailsData} />
      }
   
    </>
    }

      <section className="blogshare">
        <div className="container">
        <div className="sharebtn">
              <button type="button" onClick={() => shareArticle()}>{t("COMMON.SHARE")} <img src={shareimage} alt="share"/></button>
            </div>
          <h2>  {t("ARTICLECHILD.ARTICLERECOMENDEDTITLE")}</h2>
          <p>  {t("ARTICLECHILD.ARTICLERECOMENDEDTAGLINE")}</p>
          <div className="innerfeaturedblog d-none d-sm-block">
            
            {similarArticle && similarArticle.length > 0 &&
                <div className="row">
                          <Slider {...trendingsectionunslick}>
                          {similarArticle.map((blog,index) =>(

                                      
                                          <div className="col smblog" key={index}>
                                              <div className={`basicstructure   ${blog.cats[0]?.name}`}>
                                                  <div className="smbloginnerps">

                                                      <ArticlesCardJSX blogslug={blog?.slug}
                                                          blogimage={blog?.image}
                                                          blogtitle={blog?.title}
                                                          blogcat={blog?.cats.map((cat) => cat.name).join(',')}
                                                          // blogshort_content={blog?.short_content}
                                                          articleauthor={blog?.author}
                                                          articledatepublish={blog?.date_publish}
                                                          isSerchArticle={false} />

                                                  </div>
                                              </div>
                                          </div>
                                      ))}
                              </Slider>
                      </div>
      }

            </div>   
            <div className="innerfeaturedblog d-block d-lg-none d-sm-none d-md-none ">
            
            {similarArticle && similarArticle.length > 0 &&
                <div className="row">
                          <Slider {...trendingsectionunslick}>
                          {similarArticle.map((blog,index) =>(

                                      
                                          <div className="col smblog" key={index}>
                                              <div className={`basicstructure   ${blog.cats[0]?.name}`}>
                                                  <div className="smbloginnerps">

                                                      <ArticlesCardJSX blogslug={blog?.slug}
                                                          blogimage={blog?.image}
                                                          blogtitle={blog?.title}
                                                          blogcat={blog?.cats.map((cat) => cat.name).join(',')}
                                                          // blogshort_content={blog?.short_content}
                                                          articleauthor={blog?.author}
                                                          articledatepublish={blog?.date_publish}
                                                          isSerchArticle={true} />

                                                  </div>
                                              </div>
                                          </div>
                                      ))}
                              </Slider>
                      </div>
      }

            </div>      
            </div>
        </section>
      
    <Footer />
    </>

  );
};

export default ArticleDetailsJsx;